
import { useMemo } from "react";
import {CategoriesBlock, HowItWorksBlock, ReviewBlock, VideoGreetingsCardBlock} from "../../blocks";


export const HomePage = () => {

    const memorizedHomePage = useMemo(() => {
        return <>
            <VideoGreetingsCardBlock />
            <HowItWorksBlock />
            <CategoriesBlock title="Category" />
            <ReviewBlock />
        </>
    }, []);

    return memorizedHomePage;
}

export default HomePage;